// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyC5bcfSFxjZr44gSqQHbZnTKSvJ1DCTWIs",
    authDomain: "tamronlanka.firebaseapp.com",
    projectId: "tamronlanka",
    storageBucket: "tamronlanka.appspot.com",
    messagingSenderId: "224429956804",
    appId: "1:224429956804:web:e6814721dc828ef2ba3391"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
